import { createOpenOrderDrawerScanAction } from '../scan_actions/openOrderDrawer.action';
import { createRedirectAndOpenOrderDrawerScanAction } from '../scan_actions/redirectAndOpenOrderDrawer.action';
import { createSubmitOrderDetailsPageScanAction } from '../scan_actions/submitOrderDetailsPage.action';
import { createSubmitOrderDrawerScanAction } from '../scan_actions/submitOrderDrawer.action';
import { type ScanAction } from '../types/scanAction.type';

/**
 * Scan action candidates in order of hierarchy.
 * Resolution takes the first match, so a higher entry wins over every entry below it.
 *
 * Submitting the drawer in front of the operator is the more specific claim, so it
 * outranks opening one: the shipment details drawer knows only its transaction, so
 * a drawer open on the scanned shipment still reads as "another order" to
 * `OpenOrderDrawer` and would otherwise reopen the drawer instead of printing.
 */
export const SCAN_ACTIONS: readonly ScanAction[] = [
  createSubmitOrderDrawerScanAction(),
  createOpenOrderDrawerScanAction(),
  createRedirectAndOpenOrderDrawerScanAction(),
  createSubmitOrderDetailsPageScanAction(),
];
